import { render, staticRenderFns } from "./CapacityTable.vue?vue&type=template&id=468fe57c&scoped=true"
import script from "./CapacityTable.vue?vue&type=script&lang=js"
export * from "./CapacityTable.vue?vue&type=script&lang=js"
import style0 from "./CapacityTable.vue?vue&type=style&index=0&id=468fe57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468fe57c",
  null
  
)

export default component.exports